import {
  DOWNLOAD_DISCOUNT_BLACKLIST,
  FETCH_DISCOUNT_SETTINGS,
  SET_UPLOADING_DISCOUNT_BLACKLIST,
  SET_DOWNLOADING_DISCOUNT_BLACKLIST,
  UPLOAD_DISCOUNT_BLACKLIST,
  UPDATE_DISCOUNT_SETTINGS,
  UPDATE_DISCOUNT_BOTTOM_PRICE,
  SET_FETCH_DISCOUNT_SETTINGS,
  SET_UPDATE_DISCOUNT_BOTTOM_PRICE,
  SET_UPDATE_DISCOUNT_SETTINGS,
  DOWNLOAD_DISCOUNT_SCHEME,
} from 'state/actionTypes';

export const updateDiscountSettings = values => ({
  type: UPDATE_DISCOUNT_SETTINGS,
  payload: {
    values,
  },
});

export const updateDiscountBottomPrice = (bottomPrice, bottomPriceType) => ({
  type: UPDATE_DISCOUNT_BOTTOM_PRICE,
  payload: {
    bottomPrice,
    bottomPriceType,
  },
});

export const fetchDiscountSettings = () => ({
  type: FETCH_DISCOUNT_SETTINGS,
});

export const setUpdateDiscountSettings = values => ({
  type: SET_UPDATE_DISCOUNT_SETTINGS,
  payload: values,
});

export const setUpdateDiscountBottomPrice = values => ({
  type: SET_UPDATE_DISCOUNT_BOTTOM_PRICE,
  payload: values,
});

export const setFetchDiscountSettings = values => ({
  type: SET_FETCH_DISCOUNT_SETTINGS,
  payload: values,
});

export const uploadDiscountBlacklist = values => ({
  type: UPLOAD_DISCOUNT_BLACKLIST,
  payload: {
    values,
  },
});

export const downloadDiscountBlacklist = () => ({
  type: DOWNLOAD_DISCOUNT_BLACKLIST,
});

export const setUploadingDiscountBlacklist = uploading => ({
  type: SET_UPLOADING_DISCOUNT_BLACKLIST,
  payload: {
    uploading,
  },
});

export const setDownloadingDiscountBlacklist = downloading => ({
  type: SET_DOWNLOADING_DISCOUNT_BLACKLIST,
  payload: {
    downloading,
  },
});

export const downloadDiscountScheme = discountSettings => ({
  type: DOWNLOAD_DISCOUNT_SCHEME,
  payload: {
    discountSettings,
  },
});
